/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { ApiRoamingCallbackService } from './services/api-roaming-callback.service';
import { ApiRoamingConfigurationService } from './services/api-roaming-configuration.service';
import { ApiRoamingWebService } from './services/api-roaming-web.service';
import { ApiRoamingRoamingService } from './services/api-roaming-roaming.service';
import { ApiRoamingCheckService } from './services/api-roaming-check.service';
import { ApiRoamingPasswordService } from './services/api-roaming-password.service';
import { ApiRoamingUrlsService } from './services/api-roaming-urls.service';
import { ApiRoamingAppIdService } from './services/api-roaming-app-id.service';
import { ApiRoamingOAuthService } from './services/api-roaming-o-auth.service';
import { ApiRoamingVersionService } from './services/api-roaming-version.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    ApiRoamingCallbackService,
    ApiRoamingConfigurationService,
    ApiRoamingWebService,
    ApiRoamingRoamingService,
    ApiRoamingCheckService,
    ApiRoamingPasswordService,
    ApiRoamingUrlsService,
    ApiRoamingAppIdService,
    ApiRoamingOAuthService,
    ApiRoamingVersionService,
    ApiConfiguration
  ],
})
export class ApiRoamingModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<ApiRoamingModule> {
    return {
      ngModule: ApiRoamingModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: ApiRoamingModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('ApiRoamingModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
